import { useRef } from 'react';
import { DateTime as DT } from 'luxon';
import type { ServiceType } from '@econtractor/types';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import CopyTextWrapper from 'components/others/CopyTextWrapper';
import PriceAndPriceSale from 'components/others/PriceAndPriceSale';
import ServiceTableRowActions from './ServiceTableRowActions';
import { useService } from './context/ServiceProvider';

interface ServiceTableRowProps {
    service: ServiceType;
    fetchServices: (force?: boolean) => Promise<unknown>;
}

const ServiceTableRow = ({ service, fetchServices }: ServiceTableRowProps) => {
    const { auth } = useAuth();
    const dt = DT.fromMillis(service?.servUpdated || 0).toFormat('dd.MM.yyyy');
    const { setShowEditService, serviceCheck, setServiceCheck } = useService();
    const refCheck = useRef<HTMLInputElement>(null);

    return (
        <tr>
            <td className="check">
                <input
                    className="form-check-input"
                    disabled={!hasUserAccess(auth?.user, 'prodEdit')}
                    ref={refCheck}
                    id={`check-service-${service.ID}`}
                    checked={serviceCheck?.includes(service.ID)}
                    onChange={(e) => {
                        setServiceCheck((prev) => {
                            if (e.target.checked) {
                                return [...prev, service.ID];
                            }
                            return prev.filter((sId) => sId !== service.ID);
                        });
                    }}
                    type="checkbox"
                />
            </td>
            <td className="name">
                <h6
                    className="mb-1 text-break cursor-pointer"
                    onClick={() => setShowEditService(service.ID)}
                >
                    {service.servName || '-'}
                </h6>
                <p className="text-muted f-12 mb-0 my-1 text-truncate" title={service.servDescription || ''}>
                    {service.servDescription || '-'}
                </p>
            </td>
            <td className="vendor">
                <h6 className="mb-1 text-break text-truncate" title={service.categoryName || ''}>
                    {service.categoryName || '-'}
                </h6>
            </td>
            <td className="id">
                <code>{service.ID}</code>
            </td>
            <td className="article text-truncate">
                <CopyTextWrapper value={service.servArticle || ''}>
                    <span title={service.servArticle}>{service.servArticle}</span>
                </CopyTextWrapper>
            </td>
            <td className="price text-truncate">
                <PriceAndPriceSale
                    price={service?.servDefPrice}
                    priceSale={service?.servDefPriceSale}
                />
            </td>
            <td className="updated">{dt}</td>
            {hasUserAccess(auth?.user, 'prodEdit') && (
                <td className="action">
                    <ServiceTableRowActions service={service} fetchServices={fetchServices} />
                </td>
            )}
        </tr>
    );
};

export default ServiceTableRow;
